import { Answer } from 'src/services/ds.service'
import { ofType, unionize, UnionOf } from 'src/framework'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { TestWithAnswers } from './test-page.reducer'

export interface LoadTest {
  type: 'LoadTest'
  token: string
  [startFetch]: string
}

export interface LoadTestSuccess {
  type: 'LoadTestSuccess'
  test: TestWithAnswers
  token: string
  [stopFetch]: string
}

export interface LoadTestFailed {
  type: 'LoadTestFailed'
  [stopFetch]: string
}

export interface SaveTest {
  type: 'SaveTest'
  token: string
  answers: Answer[]
  latest: boolean
  [startFetch]: string
}

export interface SaveTestSuccess {
  type: 'SaveTestSuccess'
  token: string
  answers: Answer[]
  latest: boolean
  [stopFetch]: string
}

export interface SaveTestFailure {
  type: 'SaveTestFailure'
  [stopFetch]: string
}

export interface SendInvites {
  type: 'SendInvites'
  token: string
  invites: { email: string; sectionName: string }[]
  [startFetch]: string
}

export interface SendInvitesSuccess {
  type: 'SendInvitesSuccess'
  [stopFetch]: string
}

export interface SendInvitesFailure {
  type: 'SendInvitesFailure'
  [stopFetch]: string
}

export const testPageActions = unionize({
  ...ofType<LoadTest>('LoadTest'),
  ...ofType<LoadTestSuccess>('LoadTestSuccess'),
  ...ofType<LoadTestFailed>('LoadTestFailed'),
  ...ofType<SaveTest>('SaveTest'),
  ...ofType<SaveTestSuccess>('SaveTestSuccess'),
  ...ofType<SaveTestFailure>('SaveTestFailure'),
  ...ofType<SendInvites>('SendInvites'),
  ...ofType<SendInvitesSuccess>('SendInvitesSuccess'),
  ...ofType<SendInvitesFailure>('SendInvitesFailure')
})

export type TestPageActions = UnionOf<typeof testPageActions>



// WEBPACK FOOTER //
// ./src/tests-components/test-page/test-page.actions.ts